import HelperLocale from "utils/helper-locale";
import _ from 'lodash';
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'

const Translate = {
	
	field: ( object, field, fallbackField = 'name', fixedLanguageCode = null, column = null ) => {
		const employeeLanguage = fixedLanguageCode !== null ? fixedLanguageCode.toLowerCase() : Translate.getLanguageCode( true );
		
		const translation = _.find( _.get( object, 'translations', [] ), o => {
			return _.toLower( o.language.code ) === employeeLanguage && o.field === field;
		});
		
		if( column === null ){
			column = field;
		}
		
		return _.get( translation, column, _.get( object, fallbackField, null ) )
	},
	
	getLanguageCode: ( lowercase = false) => {
		const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
		
		let employeeLanguage = _.get( _employee, ['language', 'code'], null );
		if( employeeLanguage === null ) {
			employeeLanguage = HelperLocale.getDeviceLocale();
		}
		
		if( lowercase ) {
			return _.toLower( employeeLanguage );
		}
		
		return employeeLanguage;
	},
	
	/**
	 *
	 * @param object
	 * @param field
	 * @param language
	 * @returns {Exclude<unknown, undefined> | any}
	 */
	formField: ( object, field, language, column = null ) => {
		return Translate.field( object, field, null, language.code, column )
	},
}

export default Translate
